// extracted by mini-css-extract-plugin
export var actionButton = "_50-1";
export var actionButtons = "_50-2";
export var actions = "_50-0";
export var aiUnread = "_50-10";
export var alignCenter = "_50-h";
export var backWrapper = "_50-3";
export var cellContainer = "_50-4";
export var checkboxContainer = "_50-5";
export var contentContainer = "_50-6";
export var contentHeader = "_50-8";
export var conversationsTableWrapper = "_50-s";
export var draftReplyBadgeContainer = "_50-m";
export var dropdownItem = "_50-b";
export var dropdownItemsContainer = "_50-a";
export var dropdownTitle = "_50-c";
export var errorIcon = "_50-7";
export var filter = "_50-d";
export var gray = "_50-i";
export var headerActionButtons = "_50-e";
export var headerCheckboxContainer = "_50-f";
export var icon = "_50-j";
export var menuContainer = "_50-k";
export var noMoreTicketsIcon = "_50-12";
export var noMoreTicketsSubText = "_50-13";
export var oneLine = "_50-l";
export var optionsButton = "_50-n";
export var plus = "_50-o";
export var portalButtonsWrapper = "_50-g";
export var red = "_50-p";
export var scrolledTop = "_50-9";
export var search = "_50-q";
export var selectedConversationsCount = "_50-r";
export var spinner = "_50-t";
export var strong = "_50-u";
export var summaryCell = "_50-v";
export var tableContainer = "_50-11";
export var tagContainer = "_50-w";
export var threeDots = "_50-x";
export var twoLines = "_50-y";
export var unread = "_50-z";